import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=218bc248&scoped=true&"
import script from "./Poll.vue?vue&type=script&lang=js&"
export * from "./Poll.vue?vue&type=script&lang=js&"
import style0 from "./Poll.vue?vue&type=style&index=0&id=218bc248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218bc248",
  null
  
)

export default component.exports